export default __webpack_public_path__ + "assets/images/fill-form-stars-a64b7d76.png";